// extracted by css-extract-rspack-plugin
module.exports =  {"text":"StaffingHeader__text____2gA4"};